import Vue from 'vue'
import Vuex from 'vuex'
import api from '../api'
Vue.use(Vuex)

const TYPES = {
	'TOKEN': 'TOKEN',
	'USER_INFO': 'USER_INFO',
	'MEMBER_INFO': 'MEMBER_INFO',
	'APPOINTMENTS': 'APPOINTMENTS',
	'LOADING': 'LOADING',
	'DOWNLOAD_URL': 'DOWNLOAD_URL'
}
export default new Vuex.Store({
	state: {
		token: '',
		minfo: {},
		appointments: [],

		loading: false,


		iosUrl: "",
		androidUrl: ""
	},
	mutations: {
		[TYPES.TOKEN](state, token) {
			state.token = token
		},
		[TYPES.MEMBER_INFO](state, minfo) {
			state.minfo = minfo
		},
		[TYPES.APPOINTMENTS](state, appointments) {
			state.appointments = appointments
		},
		[TYPES.LOADING](state, loading) {
			state.loading = loading
		},
		[TYPES.DOWNLOAD_URL](state, {
			iosUrl,
			androidUrl
		}) {
			state.iosUrl = iosUrl
			state.androidUrl = androidUrl
		}
	},
	actions: {
		async setToken(context, token = false) {
			context.commit(TYPES.TOKEN, token)
			if (token) {
				context.dispatch('getMemberInfo')
			}
		},
		async getMemberInfo(context) {
			const response = await api.get('/get_user')
			if (response && response.code == 200) {
				context.commit(TYPES.MEMBER_INFO, response.data)
				return response.data
			}
			return Promise.reject(false)
		},
		async setMemberInfo(context, minfo = {}) {
			context.commit(TYPES.MEMBER_INFO, minfo)
		},
		async syncMemberInfo(context) {
			if (context.state.minfo.uid) {
				return context.state.minfo
			}
			return context.dispatch('getMemberInfo')
		},
		async getAppointments(context) {
			const response = await api.get('/web/appointment/list')
			if (response) {
				const appointments = []
				Object.keys(response.data).forEach(date => {
					appointments.push({
						date,
						lists: response.data[date]
					})
				})
				context.commit(TYPES.APPOINTMENTS, appointments)
			}
		},
		async setLoading(context, show) {
			context.commit(TYPES.LOADING, show)
		},
		async getDownloadUrls(context) {
			const response = await api.get('/web/download')
			if (response.code == 200) {
				const {
					android_url,
					ios_url
				} = response.data
				const apk = /03zbb\.com/.test(location.hostname) ? 'https://imim.zsw998.com/01zbb_v1.0.5-20230517_20-46-46.apk' : android_url

				context.commit(TYPES.DOWNLOAD_URL, {
					iosUrl: ios_url,
					androidUrl: apk
				})
			}
			return response.data
		}
	}
})
